<template>
  <div>
    <div v-if="!fetchLoading">
      <v-list>
        <v-list-item v-for="(child, index) in children" :key="index" class="mb-4">
            <div class="d-flex justify-space-between mb-2 text-caption">
              {{ child.lastName }} {{ child.firstName }}
              <div>
                <v-btn color="secondary" class="mr-3" variant="outlined" size="x-small" @click="clickToParentsRecord(child)" >{{ $t('records.parentsRecordTitle') }}</v-btn>
                <v-btn color="primary" variant="outlined" size="x-small" @click="clickDialog(child)"
                  >{{ $t('records.addRecord') }}</v-btn
                >
              </div>
            </div>
            <ChildOtherRecordListVue
              :classOtherReport="classOtherReport"
              :child="child"
              @changeDefecation="changeDefecationModal"
              @changeTemperature="changeTemperatureModal"
              @changeMilk="changeMilkModal"
              @changeSleep="changeSleepModal"
            />
        </v-list-item>
      </v-list>
    </div>
    <div v-else>
      <VueLoading :height="'50vh'" />
    </div>

    <!-- 記録作成モーダル -->
    <v-dialog v-model="isRecordDialog" max-width="720" persistent>
      <v-card>
        <v-card-title class="d-flex align-center justify-center">
          {{ $t('records.addRecordTitle') }}
        </v-card-title>
        <v-card-subtitle v-if="inputChild" class="pt-2 d-flex align-center justify-center">
          {{ inputChild.lastName }} {{ inputChild.firstName }}
        </v-card-subtitle>

        <v-card-text>
          <v-radio-group 
          v-model="otherRecord" 
          row
          @update:model-value="recordedAt = ''"
          >
            <div class="d-flex">
            <v-radio :label="$t('records.temperature')" value="temperature"></v-radio>
            <v-radio :label="$t('records.milk')" value="milk"></v-radio>
            </div>
            <div class="d-flex">
              <v-radio :label="$t('records.defecation')" value="defecation"></v-radio>
            <v-radio :label="$t('records.sleep')" value="sleep"></v-radio>
            </div>
          </v-radio-group>
          <template v-if="otherRecord === 'defecation'">
            <DefecationModal 
              v-model:recordedAt="recordedAt"
              v-model:state="state"
            />
          </template>
          <template v-if="otherRecord === 'temperature'">
            <TemperatureModal
              v-if="inputChild"
              :inputChild="inputChild"
              v-model:recordedAt="recordedAt"
              v-model:temperature="temperature"
              @changeRecordedAt="changeRecordedAt"
              @changeTemperature="changeTemperature"
            />
          </template>
          <template v-if="otherRecord === 'milk'">
            <MilkModal
              v-model:recordedAt="recordedAt"
              v-model:amount="amountId"
              v-model:milkCategory="milkCategory"
            />
          </template>
          <template v-if="otherRecord === 'sleep'">
            <SleepModal
              v-model:from="from"
              v-model:to="to"
            />
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row class="mt-2 mb-2">
            <v-col cols="6" class="pr-2 pl-2">
              <v-btn class="" color="#6C6C6C" dark variant="flat" width="100%" @click="clickCancel">
                <div>
                  <div class="text-h6 font-weight-bold message-btn">{{ $t('common.cancel') }}</div>
                </div>
              </v-btn>
            </v-col>

            <v-col cols="6" class="pl-1 pr-2">
              <v-btn
                class=""
                color="primary"
                variant="flat"
                width="100%"
                @click="saveOtherRecord"
                :disabled="!isSaveOtherRecord"
                :loading="btnLoading"
              >
                <div>
                  <div class="text-h6 font-weight-bold message-btn">{{ $t('common.save') }}</div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 記録修正・削除モーダル -->

    <v-dialog v-model="isChangeRecordDialog" max-width="720" persistent>
      <v-card>
        <v-card-title class="align-center justify-center">
          {{ $t('records.editDeleteRecord') }}
        </v-card-title>

        <v-card-text :class="{ 'edit-record-card-text': $i18n.locale === 'en' }">
          <template v-if="inputDefecation">
            <DefecationModal
              :defecationTemp="inputDefecation"
              v-model:recordedAt="recordedAt"
              v-model:state="state"
            />
          </template>
          <template v-if="inputTemperature">
            <TemperatureModal
              :temperatureTemp="inputTemperature"
              v-model:recordedAt="recordedAt"
              v-model:temperature="temperature"
              @changeRecordedAt="changeRecordedAt"
              @changeTemperature="changeTemperature"
            />
          </template>
          <template v-if="inputMilk">
            <MilkModal
              :milkTemp="inputMilk"
              v-model:recordedAt="recordedAt"
              v-model:amount="amountId"
              v-model:milkCategory="milkCategory"
            />
          </template>
          <template v-if="inputSleep">
            <SleepModal
              :sleepTemp="inputSleep"
              v-model:from="from"
              v-model:to="to"
            />
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row class="mt-2 mb-2">
            <v-col cols="4" class="pr-1 pl-2">
              <v-btn class="" color="#6C6C6C" dark variant="flat" width="100%" @click="clickCancel">
                <div>
                  <div class="text-body-2 font-weight-bold message-btn">{{ $t('common.cancel') }}</div>
                </div>
              </v-btn>
            </v-col>

            <v-col cols="4" class="pl-1 pr-2">
              <v-btn
                class=""
                color="error"
                variant="outlined"
                width="100%"
                @click="removeRecord"
                :loading="btnRemoveLoading"
              >
                <div>
                  <div class="text-body-2 font-weight-bold message-btn">{{ $t('common.delete') }}</div>
                </div>
              </v-btn>
            </v-col>

            <v-col cols="4" class="pl-1 pr-2">
              <v-btn
                class=""
                color="primary"
                variant="flat"
                width="100%"
                @click="changeOtherRecord"
                :loading="btnLoading"
                :disabled="!isSaveOtherRecord"
              >
                <div>
                  <div class="text-body-2 font-weight-bold message-btn">{{ $t('common.save') }}</div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import ChildOtherRecordListVue from '@/components/molecules/ChildOtherRecordList.vue';
import { diaryReportModule } from '@/store/dataModules/diaryReportModule';

import TemperatureModal from '@/components/molecules/TemperatureModal.vue';
import MilkModal from '@/components/molecules/MilkModal.vue';
import SleepModal from '@/components/molecules/SleepModal.vue';
import DefecationModal from '@/components/molecules/DefecationModal.vue';
import VueLoading from '@/components/pages/Loding.vue';

import {
  ChildResponse,
  NurseryChildResponse,
  NurseryClassResponse,
  NurseryDailyReportResponse,
  NurseryDefecationResponse,
  NurseryMilkResponse,
  NurseryTemperatureResponse,
  SleepResponse,
} from 'chaild-api/lib';
import dayjs from 'dayjs';

import Vue, { PropType } from 'vue';
import { defineComponent } from "vue";
import { childrenModule } from '@/store/dataModules/childrenModule';
export default defineComponent({
  components: {
    ChildOtherRecordListVue,
    TemperatureModal,
    MilkModal,
    SleepModal,
    DefecationModal,
    VueLoading,
  },
  props: {
    children: {
      type: Array as PropType<NurseryChildResponse[]>,
      required: true,
    },
    clas: {
      type: Object as PropType<NurseryClassResponse>,
      required: true,
    },
    date: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  data: () => {
    return {
      fetchLoading: false,
      preRecordedAt: '',
      recordedAt: '',
      from: '',
      to: '',
      state: '',
      temperature: 365 / 10,
      amountId: 10,
      milkCategory: 'formula',
      isRecordDialog: false,
      isChangeRecordDialog: false,
      otherRecord: 'temperature',
      inputChildId: NaN,
      inputChild: null as ChildResponse | null,
      btnLoading: false,
      btnRemoveLoading: false,
      inputDefecation: null as NurseryDefecationResponse | null,
      inputTemperature: null as NurseryTemperatureResponse | null,
      inputMilk: null as NurseryMilkResponse | null,
      inputSleep: null as SleepResponse | null,
      // classOtherReport: [] as NurseryDailyReportResponse[],
    };
  },
  computed: {
    classOtherReport(): NurseryDailyReportResponse[] | null {
      if (diaryReportModule.classOtherReport) {
        return diaryReportModule.classOtherReport;
      }
      return null;
    },
    isSaveOtherRecord(): boolean {
      if (this.recordedAt && this.state) {
        return true;
      } else if (this.recordedAt && this.amountId) {
        return true;
      } else if (this.recordedAt && this.temperature) {
        return true;
      } else if (this.from && this.to) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    isChangeRecordDialog: {
      handler(val: boolean) {
        if (!val) {
          this.inputChildId = NaN;
          this.inputTemperature = null;
          this.inputDefecation = null;
          this.inputMilk = null;
          this.inputSleep = null;
        }
      },
      deep: true,
    },
    isRecordDialog: {
      handler(val: boolean) {
        if (!val) {
          this.inputChildId = NaN;
        }
      },
      deep: true,
    },
  },
  methods: {
    // 記録の保存（新規作成）
    async saveOtherRecord() {
      if (this.otherRecord === 'defecation') {
        try {
          this.btnLoading = true;
          await diaryReportModule.saveChildDefecation({
            childId: this.inputChildId,
            date: this.date.format('YYYY-MM-DD'),
            recordedAt: this.recordedAt,
            state: this.state,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.state = '';
        }
      } else if (this.otherRecord === 'temperature') {
        try {
          this.btnLoading = true;
          await diaryReportModule.saveChildTemperature({
            childId: this.inputChildId,
            date: this.date.format('YYYY-MM-DD'),
            recordedAt: this.recordedAt,
            temperature: this.temperature,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.temperature = 365 / 10;
        }
      } else if (this.otherRecord === 'milk') {
        try {
          this.btnLoading = true;
          await diaryReportModule.saveChildMilk({
            childId: this.inputChildId,
            date: this.date.format('YYYY-MM-DD'),
            recordedAt: this.recordedAt,
            amountId: this.amountId,
            milkCategory: this.milkCategory,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.amountId = 10;
          this.milkCategory = 'formula';
        }
      } else if (this.otherRecord === 'sleep') {
        try {
          this.btnLoading = true;
          await diaryReportModule.saveChildSleep({
            childId: this.inputChildId,
            date: this.date.format('YYYY-MM-DD'),
            from: this.from,
            to: this.to,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.from = '';
          this.to = '';
        }
      }
      this.preRecordedAt = '';
      this.isRecordDialog = false;
    },

    // 記録の変更
    async changeOtherRecord() {
      if (this.inputDefecation) {
        try {
          this.btnLoading = true;
          await diaryReportModule.updateChildDefecation({
            childId: this.inputChildId,
            defecationId: this.inputDefecation.defecationId,
            recordedAt: this.recordedAt,
            state: this.state,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.state = '';
          this.inputDefecation = null;
        }
      } else if (this.inputTemperature) {
        try {
          this.btnLoading = true;
          await diaryReportModule.updateChildTemperature({
            childId: this.inputChildId,
            temperatureId: this.inputTemperature.temperatureId,
            recordedAt: this.recordedAt,
            temperature: this.temperature,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.temperature = 365 / 10;
          this.inputTemperature = null;
        }
      } else if (this.inputMilk) {
        try {
          this.btnLoading = true;
          await diaryReportModule.updateChildMilk({
            childId: this.inputChildId,
            milkId: this.inputMilk.milkId,
            recordedAt: this.recordedAt,
            amountId: this.amountId,
            milkCategory: this.milkCategory,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.amountId = 10;
          this.inputMilk = null;
        }
      } else if (this.inputSleep) {
        try {
          this.btnLoading = true;
          await diaryReportModule.updateChildSleep({
            sleepId: this.inputSleep.sleepId,
            from: this.from,
            to: this.to,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.amountId = 10;
          this.inputSleep = null;
        }
      }
      this.isChangeRecordDialog = false;
    },

    // 記録の削除
    async removeRecord() {
      if (this.inputDefecation) {
        try {
          this.btnRemoveLoading = true;
          await diaryReportModule.deleteChildDefecation({
            childId: this.inputChildId,
            defecationId: this.inputDefecation.defecationId,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnRemoveLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.state = '';
          this.inputDefecation = null;
        }
      } else if (this.inputTemperature) {
        try {
          this.btnRemoveLoading = true;
          await diaryReportModule.deleteChildTemperature({
            childId: this.inputChildId,
            temperatureId: this.inputTemperature.temperatureId,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnRemoveLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.temperature = 365 / 10;
          this.inputTemperature = null;
        }
      } else if (this.inputMilk) {
        try {
          this.btnRemoveLoading = true;
          await diaryReportModule.deleteChildMilk({
            childId: this.inputChildId,
            milkId: this.inputMilk.milkId,
          });
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnRemoveLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.amountId = 10;
          this.inputMilk = null;
        }
      }  else if (this.inputSleep) {
        try {
          this.btnRemoveLoading = true;
          await diaryReportModule.deleteChildSleep(this.inputSleep.sleepId);
          diaryReportModule.fetchChildOtherReport({
            classId: this.clas.classId.toString(),
            date: this.date.format('YYYY-MM-DD'),
          });
        } catch {
        } finally {
          this.btnRemoveLoading = false;
          this.inputChildId = NaN;
          this.recordedAt = '';
          this.amountId = 10;
          this.inputSleep = null;
        }
      }
      this.isChangeRecordDialog = false;
    },

    changeRecordedAt(recordedAt: string) {
      this.preRecordedAt = recordedAt
      const recordedAtHour = recordedAt.split(':')[0];
      const recordedAtMinutes = recordedAt.split(':')[1];
      const recordedAtTime = dayjs()
        .hour(Number(recordedAtHour))
        .minute(Number(recordedAtMinutes));
      this.recordedAt = dayjs(recordedAtTime).toISOString();
    },
    changeFrom(recordedAt: string) {
      const recordedAtHour = recordedAt.split(':')[0];
      const recordedAtMinutes = recordedAt.split(':')[1];
      const recordedAtTime = dayjs()
        .hour(Number(recordedAtHour))
        .minute(Number(recordedAtMinutes));
      this.from = dayjs(recordedAtTime).toISOString();
    },
    changeTo(recordedAt: string) {
      const recordedAtHour = recordedAt.split(':')[0];
      const recordedAtMinutes = recordedAt.split(':')[1];
      const recordedAtTime = dayjs()
        .hour(Number(recordedAtHour))
        .minute(Number(recordedAtMinutes));
      this.to = dayjs(recordedAtTime).toISOString();
    },
    changeState(state: string) {
      this.state = state;
    },
    changeTemperature(temperature: number) {
      this.temperature = temperature;
    },
    changeAmount(amountId: number) {
      this.amountId = amountId;
    },
    changeMilkCategory(milkCategory: string) {
      this.milkCategory = milkCategory;
    },
    clickDialog(child: ChildResponse) {
      this.otherRecord = 'temperature'
      this.inputChild = child
      this.inputChildId = child.childId;
      this.isRecordDialog = true;
    },
    clickCancel() {
      this.isRecordDialog = false;
      this.isChangeRecordDialog = false;
      this.inputChildId = NaN;
      this.inputTemperature = null;
      this.inputDefecation = null;
      this.inputMilk = null;
      this.inputSleep = null;
      this.recordedAt = '';
    },
    changeDefecationModal(defecation: NurseryDefecationResponse, child: NurseryChildResponse) {
      console.log('changeDefecation', defecation);
      console.log('child', child);
      this.inputDefecation = defecation;
      this.inputChildId = child.childId;
      this.isChangeRecordDialog = true;
    },
    changeTemperatureModal(temperature: NurseryTemperatureResponse, child: NurseryChildResponse) {
      console.log('changeTemperature', temperature);
      console.log('child', child);
      this.inputTemperature = temperature;
      this.inputChildId = child.childId;
      this.isChangeRecordDialog = true;
    },
    changeMilkModal(milk: NurseryMilkResponse, child: NurseryChildResponse) {
      console.log('changeMilk', milk);
      console.log('child', child);
      this.inputMilk = milk;
      this.inputChildId = child.childId;
      this.isChangeRecordDialog = true;
    },
    changeSleepModal(sleep: SleepResponse, child: NurseryChildResponse) {
      console.log('changeSleep', sleep);
      console.log('child', child);
      this.inputSleep = sleep;
      this.inputChildId = child.childId;
      this.isChangeRecordDialog = true;
    },
    clickToParentsRecord(child: NurseryChildResponse) {
      this.$router.push({
        path: `/record/parents-record/class/${this.clas.classId}/child/${child.childId}`,
        query: { date: `${this.date.toISOString()}` }
      });
    }
  },
  mounted: async function() {
    this.fetchLoading = true;
    Promise.all([
      diaryReportModule.fetchChildOtherReport({
        classId: this.clas.classId.toString(),
        date: this.date.format('YYYY-MM-DD'),
      }),
      diaryReportModule.getChildMilkChoice()
    ]);
    this.$nextTick(() => {
      this.fetchLoading = false;
    });
    // if (diaryReportModule.classOtherReport) {
    //   console.log(diaryReportModule.classOtherReport);
    //   this.classOtherReport = diaryReportModule.classOtherReport;
    // }
  },
});
</script>
<style lang="scss" scoped>
.edit-record-card-text {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>
